import React, { Component } from "react";
import UserManagementRouter from "./components/routes";
export class UserManagementWrapper extends Component {
  login() {
    this.props.auth.login();
  }
  render() {
    const { isAuthenticated } = this.props.auth;

    return (
      <div
        style={{
          // height: "100%",
          // minHeight: "100%",
          // position: "relative",
          // top: "45px"
          position: "absolute",
          top: "44px",
          bottom: "0px",
          left: "0px",
          right: "0px",
        }}>
        {isAuthenticated() && (
          //<div style={{ height: "100%", minHeight: "100%" }}>
          <div style={{ height: "100%" }}>
            <UserManagementRouter />
          </div>
        )}
      </div>
    );
  }
}
